import { DropdownSelectorType } from '../types/interfaces';

export const ObjectCharacteristicFilterOptions: DropdownSelectorType[] = [
  { label: 'Гц', id: 1703873956536 },
  { label: 'См', id: 1703873956534 },
  { label: 'М', id: 1703873956533 },
  { label: 'Км', id: 1703873956532 },
  { label: 'кВт', id: 1703873956531 },
  { label: 'Мбит', id: 17038739565301 },
  { label: 'Кг', id: 17038739565302 },
  { label: 'Н', id: 17038739565303 },
  { label: 'С', id: 17038739565304 },
  { label: 'Нет', id: 17038739565305 }
];
